import { Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ConfigOption, FormlyConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';

import { PersonSearchComponent } from './person-search/person-search.component';
import { MatFormlyInlineSearchComponent } from './inline-search/mat-formly-inline-search.component';
import { InlinePersonSearchComponent } from './inline-person-search/inline-person-search.component';
import { MatFormlyButtonComponent } from './mat-formly-button/mat-formly-button.component';
import { MatFormlyNoteTranslationComponent } from './mat-formly-note-translation/mat-formly-note-translation.component';
import { NoteTranslationComponent } from '../translation/note-translation/note-translation.component';
import { AhsFormlySharedModule, FormlyConfigService } from '@nx-ahs/formly/shared';
import { SearchModule } from '@nx-ahs/search';
import { BuilderService } from '@nx-ahs/formly/builder';

@NgModule({
	declarations: [
		PersonSearchComponent,
		InlinePersonSearchComponent,
		MatFormlyInlineSearchComponent,
		MatFormlyButtonComponent,
		MatFormlyNoteTranslationComponent
	],
	imports: [
		CommonModule,
		MatTreeModule,
		MatButtonModule,
		MatIconModule,
		MatDividerModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		MatExpansionModule,
		MatCardModule,
		MatCheckboxModule,
		MatRadioModule,
		MatProgressSpinnerModule,
		MatGridListModule,
		FontAwesomeModule,
		MatFormFieldModule,
		FlexLayoutModule,
		MatTooltipModule,
		MatPaginatorModule,
		FormlyModule,
		AhsFormlySharedModule,
		SearchModule,
		NoteTranslationComponent
	]
})
export class FormlyCustomComponentsModule {
	constructor(
		private formlyConfigService: FormlyConfigService,
		private builderService: BuilderService
	) {
		const config: ConfigOption = {
			types: [
				{ name: 'formly-person-search', component: PersonSearchComponent },
				{ name: 'mat-formly-inline-search', component: MatFormlyInlineSearchComponent },
				{ name: 'formly-inline-person-search', component: InlinePersonSearchComponent },
				{ name: 'mat-formly-button', component: MatFormlyButtonComponent },
				{ name: 'mat-formly-note-translation', component: MatFormlyNoteTranslationComponent }
			]
		};

		this.formlyConfigService.mergeConfig(config);

		this.builderService.blocks.push({
			name: 'person-search',
			category: 'custom',
			click: this.addPersonSearch.bind(this)
		});

		this.builderService.blocks.push({
			name: 'inline-person-search',
			category: 'custom',
			click: this.addInlinePersonSearch.bind(this)
		});

		this.builderService.blocks.push({
			name: 'button',
			category: 'custom',
			click: this.addButton.bind(this)
		});

		this.builderService.blocks.push({
			name: 'note-translation',
			category: 'custom',
			click: this.addNoteTranslation.bind(this)
		});
	}

	public addPersonSearch(key?: string): FormlyFieldConfig {
		return {
			key: key || 'replace',
			type: 'formly-person-search',
			props: {
				searchId: null,
				personInsertId: null,
				allowCreatePerson: null,
				name: null,
				description: null,
				required: null,
				disabled: false,
				exclude: false
			} as any,
			hideExpression: null
		} as FormlyFieldConfig;
	}

	public addButton(key?: string): FormlyFieldConfig {
		return {
			key: key || 'button',
			type: 'mat-formly-button',
			props: {
				label: 'Go Back',
				icon: ['fass', 'arrow-left'],
				color: null,
				variant: 'raised',
				action: 'navBack',
				navTo: null,
				disabled: false,
				exclude: true
			} as any
		} as FormlyFieldConfig;
	}

	public addNoteTranslation(key?: string): FormlyFieldConfig {
		return {
			key: key || 'noteTranslation',
			type: 'mat-formly-note-translation',
			props: {
				label: 'Notes',
				maxCharLength: 8000,
				isEncounterNotes: false,
				required: false,
				disabled: false,
				exclude: false
			} as any
		} as FormlyFieldConfig;
	}

	public addInlinePersonSearch(key?: string): FormlyFieldConfig {
		return {
			key: key || 'replace',
			type: 'formly-inline-person-search',
			props: {
				searchId: null,
				columns: [],
				checkboxes: [],
				searchFields: null,
				criteriaValues: null,
				noResultsMessage: null,
				patchSiblings: false,
				pageSize: 5,
				required: false,
				disabled: false
			} as any
		} as FormlyFieldConfig;
	}
}
